<div class="rounded w-full max-w-[680px] bg-white h-full flex flex-col justify-start items-center">
	<div class="cart-body relative">
		<div class="flex justify-between items-center w-full mb-4">
			<h2 class="w-full font-semibold text-[#3c3c3c] text-2xl flex items-center gap-2">
				<span class="">Cart</span>
				<span *ngIf="cartItems.length" class="primary-color text-xs text-white rounded-full w-5 h-5 flex justify-center items-center">{{cartItems.length}}</span>
			</h2>
			<div mat-dialog-close
				 class="px-2 pt-2 rounded">
			<span class="material-symbols-outlined cursor-pointer text-black">
				close
			</span>
			</div>

		</div>


		<div class="grid grid-cols-1 gap-4">
			<div *ngFor="let item of cartItems" class="">
				<fb-cart-dialog-item [cartItem]="item"
									 [selectedCurrency]="selectedCurrency"></fb-cart-dialog-item>
			</div>
		</div>
	</div>



	<div class="flex flex-col justify-center items-center w-full mt-4 border-t py-4 px-3 md:px-4">
		<div class="flex justify-between items-center w-full gap-2 md:px-5">
			<p class="text-base md:text-xl font-bold flex flex-col justify-center">Sub Total<span class="text-xs text-gray-500 font-normal">including discounts (if any)</span></p>
			<p class="text-base md:text-xl font-bold"><span class="text-xs md:text-sm mr-0.5 grey-text">{{selectedCurrency | uppercase}}</span> {{totalAmount| currencyConverter | number:'1.2-2'}}</p>
		</div>
		<a routerLink="/checkout"
		   (click)="proceedToCheckout()"
		   mat-dialog-close
		   class="w-full primary-button py-3 mt-4 text-xl rounded-md text-center primary-button mx-1 font-medium cursor-pointer">Checkout</a>
	</div>
</div>
